import React, { useEffect, useState } from 'react'
import styles from './index.module.css'
import Title from '../../components/Title'
import Table from '../../components/Table'
import Empty from '../../components/Empty'
import { Pagination } from '../../components/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import { deleteStudyPlans, getStudyPlans, createCopyStudyPlan, setPage } from '../../actions/studyPlans'
import { BiTrash } from 'react-icons/bi'
import moment from 'moment'
import Confirmation from '../../components/Confirmation/Confirmation'
import Modal from './Modal'
import Button from '../../components/Button'
import { arrayForSelect } from '../../utils/arrayForSelect'
import TabSelectModal from '../../components/TabSelectModal/TabSelectModal'


const Index = () => {

  const dispatch = useDispatch()
  const { list, pageCount, pageNumber, loading } = useSelector(state => state.studyPlans)

  const [confirmation, setConfirmation] = useState(false);
  const [modalOpen, setModalOpen] = useState(null);
  const [select, setSelect] = useState(null);
  const [fieldValue, setFieldValue] = useState([]);
  const [filter, setFilter] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null)
  const [selectedItemsTab, setSelectedItemsTab] = useState([])
  const [tab, setTab] = useState(null)
  const [filteredTab, setFilteredTab] = useState(null)

  const pageClick = ({ selected }) => dispatch(setPage(selected))

  const acceptConfirmation = () => { // Подтвердить удаление
    dispatch(deleteStudyPlans(confirmation?.trid));
    closeModal();
    setConfirmation(false);
  };
  const rejectConfirmation = () => { // Отменить подтверждение
    setConfirmation(false);
  };

  useEffect(() => {
    dispatch(getStudyPlans())
  }, [])

  useEffect(() => {
    !!list.length && filter === null && setFilter(list)
  }, [list])

  const openModal = (data) => () => { // Открыть модалку
    setModalOpen(data)
  }

  const closeModal = () => { // Закрыть модалку
    setModalOpen(null)
  }

  const handleConfirmation = (e, data) => {
    e.stopPropagation() // Отмена действия по умолчанию (открытие модалки)
    setConfirmation(data)
  }

  const handleSelect = (data) => {
    if (select?.trid === data.trid) {
      setSelect(null)
    } else {
      setSelect(data)
    }
  }

  useEffect(() => () => dispatch(setPage(0)), []);

  useEffect(() => {
    pageNumber && dispatch(getStudyPlans(pageNumber))
  }, [pageNumber])

  useEffect(() => {
    list && setFilteredTab(list)
  }, [list])

  useEffect(() => {
    (filter == null && fieldValue.trid == 0) ? dispatch(getStudyPlans({ trids: '' })) : dispatch(getStudyPlans({ trids: fieldValue }))
  }, [fieldValue])

  useEffect(() => {
    const arr = list?.filter(el => selectedItemsTab?.find(item => item == el[tab]))
    setFilteredTab(arr?.length ? arr : list)
  }, [selectedTab])

  const handleFieldValue = (name, value) => {
    setFieldValue((prev) => [...prev, value])
  }
  const clearFilter = () => {
    setFieldValue([])
    setFilter(null)
  }

  const closeSelectedTab = () => {
    setSelectedTab(null) // выпадашка для хэдеров таблички
  }
  const setUniqArr = (arr) => {
    const uniqueValues = new Set(arr);
    const uniqueArray = [...uniqueValues];
    return uniqueArray
  }

  const getSelectTab = (tab) => () => {
    switch (tab) {
      case 'name': return (setSelectedTab(setUniqArr((list?.map(el => el.name)))), setTab(tab), setSelectedItemsTab([]))
      default:
        return []
    }
  }


  return (
    <div className={styles.wrapper}>
      <Title title="Учебные планы" />

      <div className={styles.buttons}>
        <div className={styles.filter}>
          {selectedTab &&
            <TabSelectModal
              closeModal={closeSelectedTab}
              data={selectedTab}
              selectedItemsTab={selectedItemsTab}
              setSelectedItemsTab={setSelectedItemsTab}
              height={230}
            // handleChangeStudents={handleChangeStudents}
            // selectedWeekVariant={selectedWeekVariant}
            />
          }
        </div>


        {select?.trid &&
          <div className={styles.copy}>
            <Button
              style={{ backgroundColor: "#3689FF", fontSize: "16px", top: '25px' }}
              onClick={() => dispatch(createCopyStudyPlan(select?.trid))}>Создать копию</Button>
          </div>}
        <Button
          style={{ backgroundColor: "#3689FF", fontSize: "16px", top: '25px' }}
          onClick={() => setModalOpen({
            name: '',
            edupart: '',
            periodfrom: '',
            periodtill: '',
            periodkind: '',
            trid: 'new',
            isbasic: false,
            category: '',
          })}>Добавить</Button>
      </div>
      <br />
      {list ? list.length === 0 && <Empty /> : ''}
      <Pagination
        pageCount={pageCount}
        pageNumber={pageNumber}
        onPageChange={pageClick}
        loading={loading}
      >
        {list ? list.length !== 0 &&
          <Table className={styles.table}>
            <thead>
              <tr>
                <th style={{ width: '100px' }}>№ п/п</th>
                <th onClick={getSelectTab('name')}>Название</th>
                <th >Ступень</th>
                <th style={{ width: '200px' }}>Период</th>
                <th style={{ width: '100px' }}>С</th>
                <th style={{ width: '100px' }}>По</th>
                <th style={{ width: '100px' }}>Действует</th>
                <th style={{ width: '100px' }}>Удалить</th>
              </tr>
            </thead>
            <tbody>
              {
                filteredTab?.map((data, index) => (
                  <tr
                    key={index}
                    onClick={() => handleSelect(data)}
                    onDoubleClick={openModal(data)}
                    style={{ backgroundColor: select?.trid === data.trid ? '#3689FF' : '' }}
                  >
                    <td style={{ color: select?.trid === data.trid ? 'white' : '' }}>{index + 1}</td>
                    <td style={{ color: select?.trid === data.trid ? 'white' : '' }}>{data.name}</td>
                    <td style={{ color: select?.trid === data.trid ? 'white' : '' }}>{data.edupart}</td>
                    <td style={{ color: select?.trid === data.trid ? 'white' : '' }}>{data.periodkind}</td>
                    <td style={{ color: select?.trid === data.trid ? 'white' : '' }}>{moment(data?.periodfrom).format('DD.MM.YYYY')}</td>
                    <td style={{ color: select?.trid === data.trid ? 'white' : '' }}>{moment(data?.periodtill).format('DD.MM.YYYY')}</td>
                    <td style={{ color: select?.trid === data.trid ? 'white' : '' }}>{data.isbasic ? 'Да' : 'Нет'}</td>

                    <td onClick={(e) => handleConfirmation(e, data)}>
                      <i className={styles.trash}><BiTrash /></i>
                    </td>
                  </tr>
                ))
              }

            </tbody>
          </Table>
          : ''
        }
      </Pagination>

      {modalOpen?.trid && (
        <div className={styles.modal}>
          <Modal
            modalOpen={modalOpen}
            closeModal={closeModal}
          />
        </div>
      )}

      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title="Удалить данную запись?"
          confirmation={confirmation?.name}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}

    </div>
  )
}

export default Index